import React from 'react';
import { Autocomplete, TextField } from '@mui/material';
import { Controller } from 'react-hook-form';
import { get } from 'lodash';
import { DEFAULT_TAX_SCHEME, isNoTaxScheme } from '../../constants/defaults';
import { useTranslatedMessages } from '../../hooks/useTranslatedMessages';

const TAX_SCHEME_OPTIONS = [DEFAULT_TAX_SCHEME];

const TaxSchemeSelect = ({ name, label, control, errors, readOnly = false, disabled, onTaxSchemeChange }) => {
  const { common } = useTranslatedMessages();
  const taxSchemeSelect = common.tax_scheme_select ?? {};
  const resolvedLabel = label ?? taxSchemeSelect.label;

  return (
    <Controller
      name={name}
      control={control}
      render={({ field }) => {
        return (
          <Autocomplete
            id={name}
            options={TAX_SCHEME_OPTIONS}
            readOnly={readOnly}
            disabled={disabled}
            getOptionLabel={(option) => option}
            renderInput={(params) => (
              <TextField
                {...params}
                data-testid={name}
                label={resolvedLabel}
                error={!!get(errors, name, null)}
                helperText={get(errors, name, {})?.message}
              />
            )}
            isOptionEqualToValue={(option, value) => option === value}
            onChange={(_, value) => {
              const next = value ?? '';
              field.onChange(next);
              onTaxSchemeChange?.(next);
            }}
            value={isNoTaxScheme(field.value) ? null : field.value}
          />
        );
      }}
    />
  );
};

export default TaxSchemeSelect;
